import React, {useContext} from "react";
import './PageHeader.scss';
import {CompanyContext} from "../../context/CompanyContext";
import {Company} from "../../models/company.model";
import {Invoice} from "../../models/invoice.model";
import {InvoiceContext} from "../../context/InvoiceContext";
import logo_outlet from "../../assets/images/logo_outlet.png";
import {Customer} from "../../models/customer.model";
import {CustomerContext} from "../../context/CustomerContext";
import {JobContext} from "../../context/JobContext";
import {Job} from "../../models/job.model";
import {useIsMobileDevice} from "../../hooks/useIsMobileDevice";
import LogoImage from "../LogoImage/LogoImage";
import {AutoLinkWrapper} from "@flicent/fieldpulse-react-component-library-frontend";
import {ServerDataContext} from "../../context/ServerDataContext";

interface PageHeaderProps {

}

export const PageHeader: React.FunctionComponent<PageHeaderProps> = (props) => {
    const company: Company = useContext(CompanyContext);
    const invoice: Invoice = useContext(InvoiceContext);
    const customer: Customer = useContext(CustomerContext);
    const billCustomer: Customer = useContext(ServerDataContext).billCustomer;
    const job: Job = useContext(JobContext);
    const isMobileDevice = useIsMobileDevice(true);

    return (<header>
        <div className='header-col header-logo-col'>
            {
                company.is_logo_visible
                    ? <div className='logo-container'>
                        <LogoImage imageUrl={company.logo_src || logo_outlet}></LogoImage>
                    </div>
                    : null
            }
        </div>

        <div className='header-col company-header-col'>
            {company.is_company_title_visible && isMobileDevice ? <h1>{company.company_title}</h1> : null}

            <div className='company-info-container'>
                {company.is_company_title_visible && !isMobileDevice ? <h1>{company.company_title}</h1> : null}

                {company.is_license_number_visible && <p>
                    {company.license_number}
                </p>}
                {company.is_address_visible && <p className="address-row">
                    {company.address}
                </p>}
                {company.is_phone_visible && <p>
                    {company.phone}
                </p>}

                {company.is_email_visible && <p>
                    {company.email}
                </p>}
                {company.is_website_url_visible && <p>
                    {company.website_url}
                </p>}
                <p>
                    {invoice.invoice_title}
                </p>
                {invoice.is_reference_visible && <p>
                    {invoice.reference}
                </p>}
            </div>

            <div className='company-info-container customer-job-information-container'>

                {invoice.is_bill_to_parent_section_visible && (billCustomer.is_display_name_visible || billCustomer.is_phone_visible || billCustomer.is_email_visible || invoice.is_billing_address_visible) &&
                    <h1 className='small-mobile-h1-header'>Bill To</h1>}
                {invoice.is_bill_to_parent_section_visible && <>{billCustomer.is_display_name_visible && <p>
                    <span className="bold-text">
                        Name:&nbsp;
                    </span>
                    {billCustomer?.display_name}
                </p>}

                    {billCustomer.is_phone_visible && <p>
                    <span className="bold-text">
                        Phone:&nbsp;
                    </span>
                        {billCustomer.phone}
                    </p>}

                    {billCustomer.is_email_visible && <p>
                    <span className="bold-text">
                        Email:&nbsp;
                    </span>
                        {billCustomer.email}
                    </p>}

                    {
                        invoice.is_billing_address_visible &&
                        <p>
                    <span className="bold-text">
                        Address:&nbsp;
                    </span>
                            <span
                                className="address-row">{invoice.billing_address || customer.billing_address || customer.address}</span>
                        </p>
                    }
                </>}

                {invoice.is_bill_to_parent_section_visible &&
                    <h1 className={'small-mobile-h1-header ' + ((invoice.is_bill_to_parent && (billCustomer.is_display_name_visible || billCustomer.is_phone_visible || billCustomer.is_email_visible || invoice.is_billing_address_visible)) ? 'customer-details-header-with-billing-details' : '')}>Customer
                        Details</h1>}

                {customer.is_display_name_visible && <p>
                    <span className="bold-text">
                       Name:&nbsp;
                    </span>
                    {customer?.display_name}
                </p>}

                {customer.is_phone_visible && <p>
                    <span className="bold-text">
                        Phone:&nbsp;
                    </span>
                    {customer.phone}
                </p>}

                {customer.is_email_visible && <p>
                    <span className="bold-text">
                        Email:&nbsp;
                    </span>
                    {customer.email}
                </p>}

                {
                    customer.is_address_visible &&
                    <p>
                    <span className="bold-text">
                        {customer.is_billing_address_visible ? 'Service Address: ' : 'Address: '}
                    </span>
                        <br/>
                        {
                            customer.is_billing_address_visible && customer.is_billing_name_visible
                                ? <p>
                                    {customer.name_without_parent}
                                    <br/>
                                    <span className="address-row">{customer.address}</span>
                                </p>
                                : <span className="address-row">{customer.address}</span>
                        }
                    </p>
                }

                {
                    customer.is_customer_main_address_visible &&
                    <p>
                        <span className="bold-text">Customer Address: </span>
                        <br/>
                        <span className="address-row">{customer.customer_main_address}</span>
                    </p>
                }

                {
                    customer.is_billing_address_visible &&
                    <p>
                        <span className="bold-text">Billing Address: </span>
                        <br/>
                        {
                            customer.is_billing_name_visible
                                ? <p>{customer.billing_name}<br/>
                                    <span className="address-row">{customer.billing_address}</span>
                                </p>
                                : <span className="address-row">{customer.billing_address}</span>
                        }
                    </p>
                }


                {
                    job && (job.is_members_visible || job.is_title_visible || job.is_location_visible || job.is_job_date_visible || job.is_site_visit_date_visible)
                        ? <>
                            {
                                (job && job.is_title_visible) &&
                                <p><span
                                    className="bold-text capitalized-text">{job.job_name} title: </span> {job.title}
                                </p>
                            }
                            {
                                (job && job.is_location_visible && job.location_name !== job.location) &&
                                <p><span
                                    className="bold-text capitalized-text">{job.job_name} Location: </span> {job.location_name}
                                </p>
                            }
                            {
                                (job && job.is_location_visible) &&
                                <p><span
                                    className="bold-text capitalized-text">{job.job_name} Location Address: </span> {job.location}
                                </p>
                            }
                            {
                                (job && job.is_members_visible && job.members.length > 0) &&
                                <p><span
                                    className="bold-text capitalized-text">{job.job_name} Members: </span> {job.members}
                                </p>
                            }
                            {
                                (job && job.is_start_date_visible && job.is_job_date_visible) &&
                                <p><span
                                    className="bold-text capitalized-text">{job.job_name} Time: </span> {job.start_date}
                                </p>
                            }

                            {
                                (job && job.is_site_visit_date_visible) &&
                                <>{job.site_visits.map((siteVisit) => {
                                    if (siteVisit.is_start_date_visible) {
                                        return <p><span
                                            className="bold-text capitalized-text">Site Visit Time: </span> {siteVisit.start_date}
                                        </p>
                                    }
                                    return null;
                                })}</>
                            }
                        </>
                        : null
                }

                <p>
                    {
                        invoice.is_invoiced_date_visible &&
                        <span className="bold-text">{invoice.is_estimate ? 'Date: ' : 'Invoiced Date: '}</span>

                    }
                    {invoice.invoiced_date}
                </p>

                <p>
                    {
                        invoice.is_due_date_visible && <><span
                            className="bold-text">{invoice.is_estimate ? 'Expiration Date' : 'Due Date'}: </span> {invoice.due_date}</>
                    }
                </p>

                <p>
                    {
                        invoice.is_author_name_visible && <><span
                            className="bold-text">Author: </span> {invoice.author_name}</>
                    }
                </p>

                <p>
                    {
                        (invoice.custom_fields)?.map((customField, index) => {
                            return <p key={index}><span className='bold-text'>{customField.name}: </span> <span
                                className='custom-field-value'><AutoLinkWrapper>{customField.value}</AutoLinkWrapper></span>
                            </p>
                        })
                    }
                </p>
            </div>
        </div>

    </header>);
}
